<template>
  <ExpertWorkPlace v-if="isExpertOrg" />
  <AdminWorkPlace v-else />
</template>
<script>
import { IsExpertOrg } from '@/utils/util'
import AdminWorkPlace from './AdminWorkPlace'
import ExpertWorkPlace from './ExpertWorkPlace'

export default {
  name: 'Workplace',
  components: {
    AdminWorkPlace,
    ExpertWorkPlace
  },
  async created () {
  },
  computed: {
    isExpertOrg () {
      return IsExpertOrg(this)
    }
  },
  methods: {

  },
}
</script>
